<template>
  <section class="container is-grid padding-left-0 padding-top-0 no-bottom-mobile">
    <div class="is-col-12-md">
      <h2>
        <strong>Want to be extra super? Post on your social media about being a Sun Hero! </strong>
      </h2>
    </div>
    <div class="sun-hero-guide-row">
      <div class="row-container">
        <SunheroThumbnailTile image="sunhero_logos_pic.png" href="/zip/Sun-Heroes-Logos.zip" title="" target="_self"
                              link="Download Sun Hero<br/> logos" :hasBorder="true"/>
        <SunheroThumbnailTile image="superhero_pic.png" href="/zip/Sun-Heroes-Social-Media-Assets.zip" title=""
                              target="_self" link="Download social<br class='br-show-mobile'/> media assets"
                              :hasBorder="true"/>
      </div>
    </div>
    <div class="pictures-callout">
      <div class="pictures-icon">
        <img src="~@/assets/images/global/pictures-icon.png"/>
      </div>
      <p>
        Please do not post any photos without a parent/guardian&rsquo;s consent. </p>
    </div>
    <div class="is-col-12-md">
      <h2 class="social-media-list-header">
        <strong>Here’s some sample copy to get you started. Simply copy and paste it into your post! </strong>
      </h2>
      <ul class="social-media-list">
        <li>I’m showing the sun who’s boss. #ImASunHero</li>
        <li>I’m creating a sun safe future. #ImASunHero</li>
        <li>I’m helping kids learn sun safe habits. #ImASunHero</li>
        <li>I’m leading the way to better sun safety for kids. #ImASunHero</li>
        <li>
          Get your cape ready and join me in helping kids stay safe in the sun. #ImASunHero
        </li>
      </ul>
    </div>
  </section>
</template>
<script>
import SunheroThumbnailTile from './SunheroThumbnailTile.vue'
import ClipboardJS from 'clipboard'

export default {
  data () {
    return {
      message: 'Copy These Text',
      messageOne: 'I’m showing the sun who’s boss. #ImASunHero',
    }
  },
  methods: {
    onCopy: function (e) {
      alert('You just copied: ' + e.text)
    },
    onError: function (e) {
      alert('Failed to copy texts')
    },
  },
  components: {
    SunheroThumbnailTile,
  },
  created () {
    var clipboard = new ClipboardJS('.test-link')

    clipboard.on('success', function (e) {
      console.info('Action:', e.action)
      console.info('Text:', e.text)
      console.info('Trigger:', e.trigger)

      e.clearSelection()
    })

    clipboard.on('error', function (e) {
      console.error('Action:', e.action)
      console.error('Trigger:', e.trigger)
    })
  },
}
</script>
<style lang="less" scoped>
@import (reference) "~@/assets/css/variables.less";

.container {
  h2 {
    font-size: 22px !important;
    color: @color-txt-blue;
    @media screen and (max-width: ~"@{mq-md-bp}em") {
      text-align: center;
    }
  }

  @media screen and (max-width: ~"@{mq-md-bp}em") {
    flex-wrap: wrap;
  }
}

.sun-hero-guide-row {
  display: flex;
  flex-flow: row nowrap;
  @media screen and (max-width: 400px) {
    flex-flow: column wrap;
  }

  .row-container {
    display: flex;
    flex-direction: row;
    @media screen and (max-width: ~"@{mq-md-bp}em") {
      flex-direction: column;
      margin-left: auto;
      margin-right: auto;
    }
  }
}

.social-media-list-header {
  font-size: 18px !important;
  @media screen and (max-width: ~"@{mq-md-bp}em") {
    text-align: center;
  }
}

.social-media-list {
  margin-left: 0;
  @media screen and (max-width: ~"@{mq-md-bp}em") {
    margin-left: 5px;
  }

  li {
    list-style: none;
    margin-bottom: 30px;
    margin-top: 0;
    font-size: 18px;

    &:nth-child(1) {
      margin-top: 30px;
    }

    &:last-child {
      margin-bottom: 0;
      @media screen and (max-width: ~"@{mq-md-bp}em") {
        margin-bottom: 0;
      }
    }
  }
}

.pictures-callout {
  display: flex;
  flex-flow: row nowrap;
  background-color: @color-yellow;
  padding: 0px 30px 0 30px;
  height: 130px;
  @media screen and (max-width: ~"@{mq-md-bp}em") {
    height: auto;
    flex-wrap: wrap;
    padding: 10px 10px 20px 50px;
  }
  @media screen and (max-width: ~"@{mq-xs-bp}") {
    width: 100%;
    padding: 10px 15px 20px 15px;
    margin-left: 3%;
    margin-right: 3%;
  }

  .pictures-icon {
    width: 100px;
    padding-top: 20px;
    @media screen and (max-width: ~"@{mq-md-bp}em") {
      width: 64px;
      padding-top: 10px;
    }

    img {
      width: 100%;
      object-fit: cover;
    }
  }

  p {
    font-weight: 700;
    font-family: @open-sans-font;
    font-size: 18px;
    color: @color-txt-blue;
    padding-top: 31px;
    padding-left: 20px;
    width: 80%;
    @media screen and (min-width: 1000px) {
      width: 328px;
    }
    height: 100px;
    box-sizing: border-box;
    @media screen and (max-width: ~"@{mq-md-bp}em") {
      width: 70%;
      height: auto;
      font-size: 14px;
      padding-left: 10px;
      padding-top: 10px;
    }
  }
}
</style>
